import { useState } from "react";
import { Button } from "../../../../../../components/Button/Button";
 
import { LoteOptionsDto } from "../type";
import { StatusLoteModal } from "../modals/statusLoteModal";
import { GrupoLoteModal } from "../modals/grupoLoteModal";
import { DeleteLoteModal } from "../modals/deleteLoteModal";
import { SaleDatesLoteModal } from "../../../../../../components/Modals/SaleDatesLote/SaleDatesLoteModal";



// mudar Grupo, Mudar Status no momento
export function LoteOptions({ isWholeSaler, hasIntegration, isAdmin, canManageSaleDates, pluginspaceId, filterProduct }: LoteOptionsDto) {
    const [openModalStatus, setOpenModalStatus] = useState(false)
    const [openModalGroup, setOpenModalGroup] = useState(false)
    const [openModalDelete, setOpenModalDelete] = useState(false)
    const [openModalSaleDates, setOpenModalSaleDates] = useState(false)
    const canDeleteLote = !hasIntegration && isWholeSaler && isAdmin


    function onCloseModals() {
        setOpenModalStatus(false)
        setOpenModalGroup(false)
        setOpenModalDelete(false)
        setOpenModalSaleDates(false)
        filterProduct && filterProduct()

    }

    return (
        <div className="py-4 ">
            <Button
                text={'Mudar em Lote Status'}
                color='primary'
                iconColor='#FFF'
                size='small'
                btnAttr={{
                    type: 'button',
                }}
                click={() => {
                    setOpenModalStatus(true)
                }}
                btnClass='fw-bolder me-5'
            />
            {isWholeSaler && canManageSaleDates && (
                <Button
                    text={'Editar Datas de Venda'}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => {
                        setOpenModalSaleDates(true)
                    }}
                    btnClass='fw-bolder me-5'
                />
            )}

            {isWholeSaler && (
                <Button
                    text={'Mudar em Lote Grupo'}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => {
                        setOpenModalGroup(true)
                    }}
                    btnClass='fw-bolder me-5'
                />
            )}

            {canDeleteLote && (
                <Button
                    text={'Deletar produto em Lote'}
                    color='danger'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => setOpenModalDelete(true)}
                    btnClass='fw-bolder me-5'
                />
            )}

            <StatusLoteModal isOpen={openModalStatus} onClose={onCloseModals} />
            {pluginspaceId ? (
                <SaleDatesLoteModal
                    isOpen={openModalSaleDates}
                    onClose={onCloseModals}
                    onSuccess={onCloseModals}
                    pluginspaceId={pluginspaceId}
                />
            ) : null}
            <GrupoLoteModal isOpen={openModalGroup} onClose={onCloseModals} />
            <DeleteLoteModal isOpen={openModalDelete} onClose={onCloseModals} />

             
        </div>
    )
}